import { getLocalesFromBrowserSettings } from '../repositories/localeRepository'

export function getBrowserLocales() {
  return getLocalesFromBrowserSettings()
}
